export default "__VITE_ASSET__95aef732__"